var ATTACHED_PADDING = 16;
var PREVIOUS_BUTTON_WIDTH_ATTACHED = 66;
var PREVIOUS_BUTTON_WIDTH_ONLINE = 60;
var getTabBounding = tab => {
  var {
    left,
    right
  } = tab.getBoundingClientRect();
  var leftBounding = left - 4;
  var rightBounding = right + 4;
  return {
    leftBounding,
    rightBounding
  };
};
var getDisplacementScroll = (tabsNode, type, hasPrevious) => {
  var attachedPadding = type === 'attached' ? ATTACHED_PADDING : 0;
  var {
    clientWidth
  } = tabsNode;
  var displacementScroll = 0;
  var previousButton = 0;
  var previousCorrection = 0;
  var nextTabWidth;
  var tabs = Array.from(tabsNode.children);
  tabs = type === 'attached' ? tabs : tabs.reverse();
  if (hasPrevious) {
    previousButton = type === 'attached' ? PREVIOUS_BUTTON_WIDTH_ATTACHED : PREVIOUS_BUTTON_WIDTH_ONLINE;
  }
  if (!hasPrevious) {
    previousCorrection = type === 'attached' ? PREVIOUS_BUTTON_WIDTH_ATTACHED : PREVIOUS_BUTTON_WIDTH_ONLINE;
  }
  do {
    var element = tabs.pop();
    var {
      offsetWidth
    } = element;
    displacementScroll += offsetWidth + attachedPadding;
    nextTabWidth = tabs[tabs.length - 1];
  } while (nextTabWidth && displacementScroll + nextTabWidth.offsetWidth <= clientWidth - previousButton);
  return displacementScroll - previousCorrection;
};
export { getTabBounding, getDisplacementScroll };